import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import {
  Button,
  Card,
  Checkbox,
  Col,
  Divider,
  Flex,
  Form,
  Input,
  Row,
  Select,
  Tag,
  Typography,
  Upload,
} from 'antd'
import { PlusOutlined, UploadOutlined } from '@ant-design/icons'
import {
  CURRENCY_OPTIONS,
  iconButtonStyle,
  POSITIVE_DECIMAL_MESSAGE,
  POSITIVE_DECIMAL_PATTERN,
  REQUIRED_FIELD,
} from 'src/pages/budget/const'

import { filterOption } from 'src/pages/budget/utils'
import { LinkifiedText, UiText } from 'src/pages/budget/components'

import { TStatus } from 'src/pages/budget/types'

import { BudgetRequest } from 'src/pages/budget/budgetRequests/types'
import { formatAmount } from 'src/pages/budget/budgetRequests/currency'

type FormRequestProps = {
  request: BudgetRequest
}

export const FormRequestPayment = ({ request }: FormRequestProps) => {
  console.log('request', request)
  const [isFrequency, setIsFrequency] = useState(() =>
    Boolean(request.autoPaymentFrequency),
  )
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()

  const [form] = Form.useForm()
  const { Title, Text, Paragraph } = Typography
  const { Item } = Form

  const handleSubmit = async (status: TStatus) => {
    // setLoadingStatus(status)
    try {
    } catch (error) {
      console.log('validation error:', error)

      //  setLoadingStatus(null)
    }
  }
  const GAP = 8

  return (
    <Card>
      <Flex
        align="center"
        gap={8}
        style={{ fontSize: 24, fontWeight: 600, marginBottom: GAP }}
      >
        Общая информация{' '}
        {request.isEarlyPayment ? (
          <Tag color="orange-inverse">Досрочная оплата</Tag>
        ) : (
          <Tag>Стандартная</Tag>
        )}
        {request.isInPlan === false && (
          <Tag color="volcano-inverse">Вне согласованного бюджета</Tag>
        )}
      </Flex>
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={8} key="">
          <Text type="secondary" style={{ fontSize: 18, marginBottom: GAP }}>
            Статья
          </Text>
          <Paragraph
            style={{ fontSize: 18 }}
            ellipsis={{
              rows: 1,
              expandable: 'collapsible',
            }}
          >
            {request.article.number}. {request.article.name}
          </Paragraph>
        </Col>
        <Col span={8} key="">
          <Text type="secondary" style={{ fontSize: 18, marginBottom: GAP }}>
            Пункт
          </Text>
          <Paragraph
            style={{ fontSize: 18 }}
            ellipsis={{
              rows: 1,
              expandable: 'collapsible',
            }}
          >
            {request.articleItem.fullNumber}. {request.articleItem.name}
          </Paragraph>
        </Col>
        <Col span={8}>
          <Text type="secondary" style={{ fontSize: 18 }}>
            Продукт
          </Text>
          <Flex gap="5" wrap style={{ marginTop: GAP }}>
            {request?.productIds?.map((product) => (
              <Tag key={product} style={{ fontSize: 14 }}>
                {product}
              </Tag>
            ))}
          </Flex>
        </Col>
      </Row>

      <Row style={{ marginBottom: 24 }}>
        <Col span={24} key="">
          <Text type="secondary" style={{ fontSize: 18, marginBottom: GAP }}>
            Описание заявки
          </Text>
          <Paragraph style={{ fontSize: 18 }}>
            <LinkifiedText text={request.description} />
          </Paragraph>
        </Col>
      </Row>

      <Title level={3} style={{ marginBottom: GAP }}>
        Общая сумма заявки на бюджет №{request.id}
      </Title>

      <Row style={{ marginBottom: 24 }} gutter={16}>
        <Col span={6} key="">
          <Text type="secondary" style={{ fontSize: 18, marginBottom: GAP }}>
            Сумма
          </Text>
          <Input value={formatAmount(request.amount, request.currency)} disabled />
        </Col>
        <Col span={6} key="">
          <Text type="secondary" style={{ fontSize: 18, marginBottom: GAP }}>
            Валюта
          </Text>
          <Input value={request.currency} disabled />
        </Col>
      </Row>

      <Flex align="center" gap={GAP} style={{ marginBottom: GAP }}>
        <Title level={3}>Заявка на оплату</Title>
        <Divider style={{ flex: 1, minWidth: 0, margin: 0, height: 2 }} />
      </Flex>

      <Form layout="vertical" form={form}>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={8}>
            <Item
              label={
                <UiText size={18} type="secondary">
                  Контрагент *
                </UiText>
              }
              name="сontractor"
              required={false}
              rules={[{ required: true, message: REQUIRED_FIELD }]}
            >
              <Select
                placeholder="Выберите ..."
                showSearch
                filterOption={filterOption}
                allowClear
                options={[]}
                popupRender={(menu) => (
                  <>
                    <Button
                      type="text"
                      style={{
                        marginTop: 5,
                        width: '100%',
                      }}
                      onClick={() => console.log('add counterparty')}
                    >
                      <Text
                        style={{
                          color: 'var(--color-primary)',
                          marginRight: 'auto',
                        }}
                      >
                        <PlusOutlined
                          style={{
                            ...iconButtonStyle,
                            color: 'var(--color-primary)',
                          }}
                        />{' '}
                        Добавить нового контрагента
                      </Text>
                    </Button>
                    <Divider style={{ margin: '8px 0' }} />

                    {menu}
                  </>
                )}
              />
            </Item>
          </Col>

          <Col xs={24} md={8}>
            <Flex gap={8}>
              <Item
                label={
                  <Text style={{ fontSize: 18 }} type="secondary">
                    Сумма *
                  </Text>
                }
                name="amount"
                style={{ flex: 2, minWidth: 100, flexShrink: 0 }}
                required={false}
                rules={[
                  { required: true, message: REQUIRED_FIELD },
                  {
                    pattern: POSITIVE_DECIMAL_PATTERN,
                    message: POSITIVE_DECIMAL_MESSAGE,
                  },
                ]}
              >
                <Input />
              </Item>

              <Item
                label={
                  <Text
                    style={{
                      fontSize: 18,
                      whiteSpace: 'nowrap',
                    }}
                    type="secondary"
                  >
                    Валюта *
                  </Text>
                }
                name="currency"
                style={{ flex: 1 }}
                required={false}
                rules={[{ required: true, message: REQUIRED_FIELD }]}
              >
                <Select options={CURRENCY_OPTIONS} />
              </Item>
            </Flex>
          </Col>
        </Row>

        <Item name="autoPaymentEnabled" valuePropName="checked">
          <Checkbox>
            <UiText
              size={18}
              type="secondary"
              style={{ display: 'inline-flex', gap: 6 }}
            >
              Подключить автоплатёж
            </UiText>
          </Checkbox>
        </Item>
        <Item
          name="documents"
          tooltip=" Документы или изображения, которые могут помочь или пригодиться
              при оплате заявки. Формыты: DOC, PDF, JPEG, PNG"
          label={
            <UiText size={18} type="secondary">
              Документы
            </UiText>
          }
        >
          <Upload accept=".doc,.docx,.pdf,.jpeg,.jpg,.png">
            <Button
              size="large"
              color="blue"
              variant="outlined"
              icon={<UploadOutlined />}
            >
              Загрузить
            </Button>
          </Upload>
        </Item>
        <Flex gap="middle" justify="flex-end" wrap>
          <Button
            size="large"
            style={{ width: 300 }}
            color="blue"
            // loading={loadingStatus === STATUS.REJECTED}
            onClick={() => console.log('!!')}
          >
            Сохранить и отправить позже
          </Button>
          <Button
            size="large"
            style={{ width: 300 }}
            variant="solid"
            color="blue"
            //loading={loadingStatus === STATUS.APPROVED}
            onClick={() => console.log('&&&&')}
          >
            Отправить на оплату
          </Button>
        </Flex>
      </Form>
    </Card>
  )
}
